/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as FreeTrialRouteImport } from './routes/free-trial'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LoginSsoRouteImport } from './routes/login-sso'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as TermsTrialRouteImport } from './routes/terms-trial'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthEndOfTrialRouteImport } from './routes/_auth/end-of-trial'
import { Route as AuthWelcomeRouteImport } from './routes/_auth/welcome'
import { Route as CustomerPortalIndexRouteImport } from './routes/customer-portal/index'
import { Route as AuthAccountProfileRouteImport } from './routes/_auth/account/profile'
import { Route as AccountPasswordRequestRouteImport } from './routes/account/password/request'
import { Route as AccountVerifyCompleteInviteRouteImport } from './routes/account/verify/complete-invite'
import { Route as AccountVerifyCompleteSignupRouteImport } from './routes/account/verify/complete-signup'
import { Route as CustomerPortalPublic_portal_tokenIndexRouteImport } from './routes/customer-portal/$public_portal_token/index'
import { Route as AuthAccountPasswordResetRouteImport } from './routes/_auth/account/password/reset'
import { Route as AuthAccountPasswordSetRouteImport } from './routes/_auth/account/password/set'
import { Route as AuthWorkspacesWorkspace_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/index'
import { Route as AccountVerifyTypeTokenRouteImport } from './routes/account/verify/$type/$token'
import { Route as AuthWorkspacesWorkspace_idCasesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/cases/index'
import { Route as AuthWorkspacesWorkspace_idCustomInventoryIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/custom-inventory/index'
import { Route as AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/customer-workspaces/index'
import { Route as AuthWorkspacesWorkspace_idDeploymentsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/deployments/index'
import { Route as AuthWorkspacesWorkspace_idDeviceDataIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/device-data/index'
import { Route as AuthWorkspacesWorkspace_idDevicesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/devices/index'
import { Route as AuthWorkspacesWorkspace_idInventoryActivitiesRouteImport } from './routes/_auth/workspaces/$workspace_id/inventory/activities'
import { Route as AuthWorkspacesWorkspace_idInventoryAssembledRouteImport } from './routes/_auth/workspaces/$workspace_id/inventory/assembled'
import { Route as AuthWorkspacesWorkspace_idInventoryConstraintsRouteImport } from './routes/_auth/workspaces/$workspace_id/inventory/constraints'
import { Route as AuthWorkspacesWorkspace_idInventoryPickingRouteImport } from './routes/_auth/workspaces/$workspace_id/inventory/picking'
import { Route as AuthWorkspacesWorkspace_idKnowledgeHubIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/knowledge-hub/index'
import { Route as AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/maintenance-strategies/index'
import { Route as AuthWorkspacesWorkspace_idMaintenancesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/maintenances/index'
import { Route as AuthWorkspacesWorkspace_idServiceJobsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/service-jobs/index'
import { Route as AuthWorkspacesWorkspace_idSettingsDetailsRouteImport } from './routes/_auth/workspaces/$workspace_id/settings/details'
import { Route as AuthWorkspacesWorkspace_idTagsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/tags/index'
import { Route as AuthWorkspacesWorkspace_idCasesCase_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/cases/$case_id/index'
import { Route as AuthWorkspacesWorkspace_idCasesInsightsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/cases/insights/index'
import { Route as AuthWorkspacesWorkspace_idCasesPlannerIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/cases/planner/index'
import { Route as AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/custom-inventory/devices/index'
import { Route as AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/custom-inventory/parts/index'
import { Route as AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/index'
import { Route as AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/deployments/$deployment_id/index'
import { Route as AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/device-data/availability/index'
import { Route as AuthWorkspacesWorkspace_idDeviceDataChartsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/device-data/charts/index'
import { Route as AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/device-data/errors/index'
import { Route as AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/device-data/missions/index'
import { Route as AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/device-data/triggers/index'
import { Route as AuthWorkspacesWorkspace_idDevicesDevice_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/devices/$device_id/index'
import { Route as AuthWorkspacesWorkspace_idInventoryIncomingIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/inventory/incoming/index'
import { Route as AuthWorkspacesWorkspace_idInventoryPartsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/inventory/parts/index'
import { Route as AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/index'
import { Route as AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/index'
import { Route as AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/knowledge-hub/files/index'
import { Route as AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/index'
import { Route as AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/index'
import { Route as AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/maintenances/insights/index'
import { Route as AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/maintenances/planner/index'
import { Route as AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/service-jobs/$service_job_id/index'
import { Route as AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/service-jobs/insights/index'
import { Route as AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/service-jobs/planner/index'
import { Route as AuthWorkspacesWorkspace_idSettingsUsersIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/settings/users/index'
import { Route as AuthWorkspacesWorkspace_idTagsCaseTagsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/tags/case-tags/index'
import { Route as AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/tags/device-tags/index'
import { Route as AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/tags/maintenance-tags/index'
import { Route as AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/index'
import { Route as AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/index'
import { Route as AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/deployments/$deployment_id/settings/index'
import { Route as AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/index'
import { Route as AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/device-data/errors/$device_error_id/index'
import { Route as AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/index'
import { Route as AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/inventory/incoming/$part_id/index'
import { Route as AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/inventory/parts/$part_id/index'
import { Route as AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/index'
import { Route as AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/index'
import { Route as AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/knowledge-hub/files/$file_id/index'
import { Route as AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/settings/users/$user_id/index'
import { Route as AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/index'
import { Route as AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/index'
import { Route as AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRouteImport } from './routes/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/index'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const FreeTrialRoute = FreeTrialRouteImport.update({
  id: '/free-trial',
  path: '/free-trial',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSsoRoute = LoginSsoRouteImport.update({
  id: '/login-sso',
  path: '/login-sso',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsTrialRoute = TermsTrialRouteImport.update({
  id: '/terms-trial',
  path: '/terms-trial',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEndOfTrialRoute = AuthEndOfTrialRouteImport.update({
  id: '/end-of-trial',
  path: '/end-of-trial',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWelcomeRoute = AuthWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AuthRoute,
} as any)
const CustomerPortalIndexRoute = CustomerPortalIndexRouteImport.update({
  id: '/customer-portal/',
  path: '/customer-portal/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccountProfileRoute = AuthAccountProfileRouteImport.update({
  id: '/account/profile',
  path: '/account/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AccountPasswordRequestRoute = AccountPasswordRequestRouteImport.update({
  id: '/account/password/request',
  path: '/account/password/request',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountVerifyCompleteInviteRoute =
  AccountVerifyCompleteInviteRouteImport.update({
    id: '/account/verify/complete-invite',
    path: '/account/verify/complete-invite',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountVerifyCompleteSignupRoute =
  AccountVerifyCompleteSignupRouteImport.update({
    id: '/account/verify/complete-signup',
    path: '/account/verify/complete-signup',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerPortalPublic_portal_tokenIndexRoute =
  CustomerPortalPublic_portal_tokenIndexRouteImport.update({
    id: '/customer-portal/$public_portal_token/',
    path: '/customer-portal/$public_portal_token/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthAccountPasswordResetRoute =
  AuthAccountPasswordResetRouteImport.update({
    id: '/account/password/reset',
    path: '/account/password/reset',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAccountPasswordSetRoute = AuthAccountPasswordSetRouteImport.update({
  id: '/account/password/set',
  path: '/account/password/set',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkspacesWorkspace_idIndexRoute =
  AuthWorkspacesWorkspace_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/',
    path: '/workspaces/$workspace_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AccountVerifyTypeTokenRoute = AccountVerifyTypeTokenRouteImport.update({
  id: '/account/verify/$type/$token',
  path: '/account/verify/$type/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthWorkspacesWorkspace_idCasesIndexRoute =
  AuthWorkspacesWorkspace_idCasesIndexRouteImport.update({
    id: '/workspaces/$workspace_id/cases/',
    path: '/workspaces/$workspace_id/cases/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCustomInventoryIndexRoute =
  AuthWorkspacesWorkspace_idCustomInventoryIndexRouteImport.update({
    id: '/workspaces/$workspace_id/custom-inventory/',
    path: '/workspaces/$workspace_id/custom-inventory/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRoute =
  AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRouteImport.update({
    id: '/workspaces/$workspace_id/customer-workspaces/',
    path: '/workspaces/$workspace_id/customer-workspaces/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDeploymentsIndexRoute =
  AuthWorkspacesWorkspace_idDeploymentsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/deployments/',
    path: '/workspaces/$workspace_id/deployments/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDeviceDataIndexRoute =
  AuthWorkspacesWorkspace_idDeviceDataIndexRouteImport.update({
    id: '/workspaces/$workspace_id/device-data/',
    path: '/workspaces/$workspace_id/device-data/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDevicesIndexRoute =
  AuthWorkspacesWorkspace_idDevicesIndexRouteImport.update({
    id: '/workspaces/$workspace_id/devices/',
    path: '/workspaces/$workspace_id/devices/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idInventoryActivitiesRoute =
  AuthWorkspacesWorkspace_idInventoryActivitiesRouteImport.update({
    id: '/workspaces/$workspace_id/inventory/activities',
    path: '/workspaces/$workspace_id/inventory/activities',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idInventoryAssembledRoute =
  AuthWorkspacesWorkspace_idInventoryAssembledRouteImport.update({
    id: '/workspaces/$workspace_id/inventory/assembled',
    path: '/workspaces/$workspace_id/inventory/assembled',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idInventoryConstraintsRoute =
  AuthWorkspacesWorkspace_idInventoryConstraintsRouteImport.update({
    id: '/workspaces/$workspace_id/inventory/constraints',
    path: '/workspaces/$workspace_id/inventory/constraints',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idInventoryPickingRoute =
  AuthWorkspacesWorkspace_idInventoryPickingRouteImport.update({
    id: '/workspaces/$workspace_id/inventory/picking',
    path: '/workspaces/$workspace_id/inventory/picking',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idKnowledgeHubIndexRoute =
  AuthWorkspacesWorkspace_idKnowledgeHubIndexRouteImport.update({
    id: '/workspaces/$workspace_id/knowledge-hub/',
    path: '/workspaces/$workspace_id/knowledge-hub/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRoute =
  AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRouteImport.update({
    id: '/workspaces/$workspace_id/maintenance-strategies/',
    path: '/workspaces/$workspace_id/maintenance-strategies/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idMaintenancesIndexRoute =
  AuthWorkspacesWorkspace_idMaintenancesIndexRouteImport.update({
    id: '/workspaces/$workspace_id/maintenances/',
    path: '/workspaces/$workspace_id/maintenances/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idServiceJobsIndexRoute =
  AuthWorkspacesWorkspace_idServiceJobsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/service-jobs/',
    path: '/workspaces/$workspace_id/service-jobs/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idSettingsDetailsRoute =
  AuthWorkspacesWorkspace_idSettingsDetailsRouteImport.update({
    id: '/workspaces/$workspace_id/settings/details',
    path: '/workspaces/$workspace_id/settings/details',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idTagsIndexRoute =
  AuthWorkspacesWorkspace_idTagsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/tags/',
    path: '/workspaces/$workspace_id/tags/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCasesCase_idIndexRoute =
  AuthWorkspacesWorkspace_idCasesCase_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/cases/$case_id/',
    path: '/workspaces/$workspace_id/cases/$case_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCasesInsightsIndexRoute =
  AuthWorkspacesWorkspace_idCasesInsightsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/cases/insights/',
    path: '/workspaces/$workspace_id/cases/insights/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCasesPlannerIndexRoute =
  AuthWorkspacesWorkspace_idCasesPlannerIndexRouteImport.update({
    id: '/workspaces/$workspace_id/cases/planner/',
    path: '/workspaces/$workspace_id/cases/planner/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRoute =
  AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRouteImport.update({
    id: '/workspaces/$workspace_id/custom-inventory/devices/',
    path: '/workspaces/$workspace_id/custom-inventory/devices/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRoute =
  AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/custom-inventory/parts/',
    path: '/workspaces/$workspace_id/custom-inventory/parts/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRoute =
  AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/',
      path: '/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRoute =
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/deployments/$deployment_id/',
    path: '/workspaces/$workspace_id/deployments/$deployment_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRoute =
  AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRouteImport.update({
    id: '/workspaces/$workspace_id/device-data/availability/',
    path: '/workspaces/$workspace_id/device-data/availability/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDeviceDataChartsIndexRoute =
  AuthWorkspacesWorkspace_idDeviceDataChartsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/device-data/charts/',
    path: '/workspaces/$workspace_id/device-data/charts/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRoute =
  AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/device-data/errors/',
    path: '/workspaces/$workspace_id/device-data/errors/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRoute =
  AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/device-data/missions/',
    path: '/workspaces/$workspace_id/device-data/missions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRoute =
  AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRouteImport.update({
    id: '/workspaces/$workspace_id/device-data/triggers/',
    path: '/workspaces/$workspace_id/device-data/triggers/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDevicesDevice_idIndexRoute =
  AuthWorkspacesWorkspace_idDevicesDevice_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/devices/$device_id/',
    path: '/workspaces/$workspace_id/devices/$device_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idInventoryIncomingIndexRoute =
  AuthWorkspacesWorkspace_idInventoryIncomingIndexRouteImport.update({
    id: '/workspaces/$workspace_id/inventory/incoming/',
    path: '/workspaces/$workspace_id/inventory/incoming/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idInventoryPartsIndexRoute =
  AuthWorkspacesWorkspace_idInventoryPartsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/inventory/parts/',
    path: '/workspaces/$workspace_id/inventory/parts/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRoute =
  AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRouteImport.update({
    id: '/workspaces/$workspace_id/knowledge-hub/case-templates/',
    path: '/workspaces/$workspace_id/knowledge-hub/case-templates/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRoute =
  AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/knowledge-hub/checklist-templates/',
      path: '/workspaces/$workspace_id/knowledge-hub/checklist-templates/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRoute =
  AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRouteImport.update({
    id: '/workspaces/$workspace_id/knowledge-hub/files/',
    path: '/workspaces/$workspace_id/knowledge-hub/files/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRoute =
  AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/',
      path: '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRoute =
  AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/maintenances/$maintenance_id/',
    path: '/workspaces/$workspace_id/maintenances/$maintenance_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRoute =
  AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/maintenances/insights/',
    path: '/workspaces/$workspace_id/maintenances/insights/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRoute =
  AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRouteImport.update({
    id: '/workspaces/$workspace_id/maintenances/planner/',
    path: '/workspaces/$workspace_id/maintenances/planner/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRoute =
  AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/service-jobs/$service_job_id/',
    path: '/workspaces/$workspace_id/service-jobs/$service_job_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRoute =
  AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/service-jobs/insights/',
    path: '/workspaces/$workspace_id/service-jobs/insights/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRoute =
  AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRouteImport.update({
    id: '/workspaces/$workspace_id/service-jobs/planner/',
    path: '/workspaces/$workspace_id/service-jobs/planner/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idSettingsUsersIndexRoute =
  AuthWorkspacesWorkspace_idSettingsUsersIndexRouteImport.update({
    id: '/workspaces/$workspace_id/settings/users/',
    path: '/workspaces/$workspace_id/settings/users/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idTagsCaseTagsIndexRoute =
  AuthWorkspacesWorkspace_idTagsCaseTagsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/tags/case-tags/',
    path: '/workspaces/$workspace_id/tags/case-tags/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRoute =
  AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/tags/device-tags/',
    path: '/workspaces/$workspace_id/tags/device-tags/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRoute =
  AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRouteImport.update({
    id: '/workspaces/$workspace_id/tags/maintenance-tags/',
    path: '/workspaces/$workspace_id/tags/maintenance-tags/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRoute =
  AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/',
      path: '/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRoute =
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/',
      path: '/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRoute =
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/deployments/$deployment_id/settings/',
      path: '/workspaces/$workspace_id/deployments/$deployment_id/settings/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRoute =
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/deployments/$deployment_id/users/',
      path: '/workspaces/$workspace_id/deployments/$deployment_id/users/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRoute =
  AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/device-data/errors/$device_error_id/',
      path: '/workspaces/$workspace_id/device-data/errors/$device_error_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRoute =
  AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/',
      path: '/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRoute =
  AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/inventory/incoming/$part_id/',
    path: '/workspaces/$workspace_id/inventory/incoming/$part_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRoute =
  AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/inventory/parts/$part_id/',
    path: '/workspaces/$workspace_id/inventory/parts/$part_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRoute =
  AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/',
      path: '/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRoute =
  AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/',
      path: '/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRoute =
  AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/knowledge-hub/files/$file_id/',
    path: '/workspaces/$workspace_id/knowledge-hub/files/$file_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRoute =
  AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRouteImport.update({
    id: '/workspaces/$workspace_id/settings/users/$user_id/',
    path: '/workspaces/$workspace_id/settings/users/$user_id/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRoute =
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/',
      path: '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRoute =
  AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/devices/$device_id/parts/$part_id/',
      path: '/workspaces/$workspace_id/devices/$device_id/parts/$part_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )
const AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRoute =
  AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRouteImport.update(
    {
      id: '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/',
      path: '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/free-trial': typeof FreeTrialRoute
  '/login': typeof LoginRoute
  '/login-sso': typeof LoginSsoRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-trial': typeof TermsTrialRoute
  '/end-of-trial': typeof AuthEndOfTrialRoute
  '/welcome': typeof AuthWelcomeRoute
  '/customer-portal/': typeof CustomerPortalIndexRoute
  '/account/profile': typeof AuthAccountProfileRoute
  '/account/password/request': typeof AccountPasswordRequestRoute
  '/account/verify/complete-invite': typeof AccountVerifyCompleteInviteRoute
  '/account/verify/complete-signup': typeof AccountVerifyCompleteSignupRoute
  '/customer-portal/$public_portal_token/': typeof CustomerPortalPublic_portal_tokenIndexRoute
  '/account/password/reset': typeof AuthAccountPasswordResetRoute
  '/account/password/set': typeof AuthAccountPasswordSetRoute
  '/account/verify/$type/$token': typeof AccountVerifyTypeTokenRoute
  '/workspaces/$workspace_id/': typeof AuthWorkspacesWorkspace_idIndexRoute
  '/workspaces/$workspace_id/inventory/activities': typeof AuthWorkspacesWorkspace_idInventoryActivitiesRoute
  '/workspaces/$workspace_id/inventory/assembled': typeof AuthWorkspacesWorkspace_idInventoryAssembledRoute
  '/workspaces/$workspace_id/inventory/constraints': typeof AuthWorkspacesWorkspace_idInventoryConstraintsRoute
  '/workspaces/$workspace_id/inventory/picking': typeof AuthWorkspacesWorkspace_idInventoryPickingRoute
  '/workspaces/$workspace_id/settings/details': typeof AuthWorkspacesWorkspace_idSettingsDetailsRoute
  '/workspaces/$workspace_id/cases/': typeof AuthWorkspacesWorkspace_idCasesIndexRoute
  '/workspaces/$workspace_id/custom-inventory/': typeof AuthWorkspacesWorkspace_idCustomInventoryIndexRoute
  '/workspaces/$workspace_id/customer-workspaces/': typeof AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRoute
  '/workspaces/$workspace_id/deployments/': typeof AuthWorkspacesWorkspace_idDeploymentsIndexRoute
  '/workspaces/$workspace_id/device-data/': typeof AuthWorkspacesWorkspace_idDeviceDataIndexRoute
  '/workspaces/$workspace_id/devices/': typeof AuthWorkspacesWorkspace_idDevicesIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/': typeof AuthWorkspacesWorkspace_idKnowledgeHubIndexRoute
  '/workspaces/$workspace_id/maintenance-strategies/': typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRoute
  '/workspaces/$workspace_id/maintenances/': typeof AuthWorkspacesWorkspace_idMaintenancesIndexRoute
  '/workspaces/$workspace_id/service-jobs/': typeof AuthWorkspacesWorkspace_idServiceJobsIndexRoute
  '/workspaces/$workspace_id/tags/': typeof AuthWorkspacesWorkspace_idTagsIndexRoute
  '/workspaces/$workspace_id/cases/$case_id/': typeof AuthWorkspacesWorkspace_idCasesCase_idIndexRoute
  '/workspaces/$workspace_id/cases/insights/': typeof AuthWorkspacesWorkspace_idCasesInsightsIndexRoute
  '/workspaces/$workspace_id/cases/planner/': typeof AuthWorkspacesWorkspace_idCasesPlannerIndexRoute
  '/workspaces/$workspace_id/custom-inventory/devices/': typeof AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRoute
  '/workspaces/$workspace_id/custom-inventory/parts/': typeof AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRoute
  '/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/': typeof AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRoute
  '/workspaces/$workspace_id/device-data/availability/': typeof AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRoute
  '/workspaces/$workspace_id/device-data/charts/': typeof AuthWorkspacesWorkspace_idDeviceDataChartsIndexRoute
  '/workspaces/$workspace_id/device-data/errors/': typeof AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRoute
  '/workspaces/$workspace_id/device-data/missions/': typeof AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRoute
  '/workspaces/$workspace_id/device-data/triggers/': typeof AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRoute
  '/workspaces/$workspace_id/devices/$device_id/': typeof AuthWorkspacesWorkspace_idDevicesDevice_idIndexRoute
  '/workspaces/$workspace_id/inventory/incoming/': typeof AuthWorkspacesWorkspace_idInventoryIncomingIndexRoute
  '/workspaces/$workspace_id/inventory/parts/': typeof AuthWorkspacesWorkspace_idInventoryPartsIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/case-templates/': typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/checklist-templates/': typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/files/': typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRoute
  '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/': typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRoute
  '/workspaces/$workspace_id/maintenances/$maintenance_id/': typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRoute
  '/workspaces/$workspace_id/maintenances/insights/': typeof AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRoute
  '/workspaces/$workspace_id/maintenances/planner/': typeof AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRoute
  '/workspaces/$workspace_id/service-jobs/$service_job_id/': typeof AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRoute
  '/workspaces/$workspace_id/service-jobs/insights/': typeof AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRoute
  '/workspaces/$workspace_id/service-jobs/planner/': typeof AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRoute
  '/workspaces/$workspace_id/settings/users/': typeof AuthWorkspacesWorkspace_idSettingsUsersIndexRoute
  '/workspaces/$workspace_id/tags/case-tags/': typeof AuthWorkspacesWorkspace_idTagsCaseTagsIndexRoute
  '/workspaces/$workspace_id/tags/device-tags/': typeof AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRoute
  '/workspaces/$workspace_id/tags/maintenance-tags/': typeof AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRoute
  '/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/': typeof AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/settings/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/users/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRoute
  '/workspaces/$workspace_id/device-data/errors/$device_error_id/': typeof AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRoute
  '/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/': typeof AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRoute
  '/workspaces/$workspace_id/inventory/incoming/$part_id/': typeof AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRoute
  '/workspaces/$workspace_id/inventory/parts/$part_id/': typeof AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/': typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/': typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/files/$file_id/': typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRoute
  '/workspaces/$workspace_id/settings/users/$user_id/': typeof AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRoute
  '/workspaces/$workspace_id/devices/$device_id/parts/$part_id/': typeof AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRoute
  '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/': typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRoute
}
export interface FileRoutesByTo {
  '/free-trial': typeof FreeTrialRoute
  '/login': typeof LoginRoute
  '/login-sso': typeof LoginSsoRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-trial': typeof TermsTrialRoute
  '/end-of-trial': typeof AuthEndOfTrialRoute
  '/welcome': typeof AuthWelcomeRoute
  '/': typeof AuthIndexRoute
  '/customer-portal': typeof CustomerPortalIndexRoute
  '/account/profile': typeof AuthAccountProfileRoute
  '/account/password/request': typeof AccountPasswordRequestRoute
  '/account/verify/complete-invite': typeof AccountVerifyCompleteInviteRoute
  '/account/verify/complete-signup': typeof AccountVerifyCompleteSignupRoute
  '/customer-portal/$public_portal_token': typeof CustomerPortalPublic_portal_tokenIndexRoute
  '/account/password/reset': typeof AuthAccountPasswordResetRoute
  '/account/password/set': typeof AuthAccountPasswordSetRoute
  '/account/verify/$type/$token': typeof AccountVerifyTypeTokenRoute
  '/workspaces/$workspace_id': typeof AuthWorkspacesWorkspace_idIndexRoute
  '/workspaces/$workspace_id/inventory/activities': typeof AuthWorkspacesWorkspace_idInventoryActivitiesRoute
  '/workspaces/$workspace_id/inventory/assembled': typeof AuthWorkspacesWorkspace_idInventoryAssembledRoute
  '/workspaces/$workspace_id/inventory/constraints': typeof AuthWorkspacesWorkspace_idInventoryConstraintsRoute
  '/workspaces/$workspace_id/inventory/picking': typeof AuthWorkspacesWorkspace_idInventoryPickingRoute
  '/workspaces/$workspace_id/settings/details': typeof AuthWorkspacesWorkspace_idSettingsDetailsRoute
  '/workspaces/$workspace_id/cases': typeof AuthWorkspacesWorkspace_idCasesIndexRoute
  '/workspaces/$workspace_id/custom-inventory': typeof AuthWorkspacesWorkspace_idCustomInventoryIndexRoute
  '/workspaces/$workspace_id/customer-workspaces': typeof AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRoute
  '/workspaces/$workspace_id/deployments': typeof AuthWorkspacesWorkspace_idDeploymentsIndexRoute
  '/workspaces/$workspace_id/device-data': typeof AuthWorkspacesWorkspace_idDeviceDataIndexRoute
  '/workspaces/$workspace_id/devices': typeof AuthWorkspacesWorkspace_idDevicesIndexRoute
  '/workspaces/$workspace_id/knowledge-hub': typeof AuthWorkspacesWorkspace_idKnowledgeHubIndexRoute
  '/workspaces/$workspace_id/maintenance-strategies': typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRoute
  '/workspaces/$workspace_id/maintenances': typeof AuthWorkspacesWorkspace_idMaintenancesIndexRoute
  '/workspaces/$workspace_id/service-jobs': typeof AuthWorkspacesWorkspace_idServiceJobsIndexRoute
  '/workspaces/$workspace_id/tags': typeof AuthWorkspacesWorkspace_idTagsIndexRoute
  '/workspaces/$workspace_id/cases/$case_id': typeof AuthWorkspacesWorkspace_idCasesCase_idIndexRoute
  '/workspaces/$workspace_id/cases/insights': typeof AuthWorkspacesWorkspace_idCasesInsightsIndexRoute
  '/workspaces/$workspace_id/cases/planner': typeof AuthWorkspacesWorkspace_idCasesPlannerIndexRoute
  '/workspaces/$workspace_id/custom-inventory/devices': typeof AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRoute
  '/workspaces/$workspace_id/custom-inventory/parts': typeof AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRoute
  '/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id': typeof AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRoute
  '/workspaces/$workspace_id/device-data/availability': typeof AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRoute
  '/workspaces/$workspace_id/device-data/charts': typeof AuthWorkspacesWorkspace_idDeviceDataChartsIndexRoute
  '/workspaces/$workspace_id/device-data/errors': typeof AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRoute
  '/workspaces/$workspace_id/device-data/missions': typeof AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRoute
  '/workspaces/$workspace_id/device-data/triggers': typeof AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRoute
  '/workspaces/$workspace_id/devices/$device_id': typeof AuthWorkspacesWorkspace_idDevicesDevice_idIndexRoute
  '/workspaces/$workspace_id/inventory/incoming': typeof AuthWorkspacesWorkspace_idInventoryIncomingIndexRoute
  '/workspaces/$workspace_id/inventory/parts': typeof AuthWorkspacesWorkspace_idInventoryPartsIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/case-templates': typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/checklist-templates': typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/files': typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRoute
  '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id': typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRoute
  '/workspaces/$workspace_id/maintenances/$maintenance_id': typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRoute
  '/workspaces/$workspace_id/maintenances/insights': typeof AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRoute
  '/workspaces/$workspace_id/maintenances/planner': typeof AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRoute
  '/workspaces/$workspace_id/service-jobs/$service_job_id': typeof AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRoute
  '/workspaces/$workspace_id/service-jobs/insights': typeof AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRoute
  '/workspaces/$workspace_id/service-jobs/planner': typeof AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRoute
  '/workspaces/$workspace_id/settings/users': typeof AuthWorkspacesWorkspace_idSettingsUsersIndexRoute
  '/workspaces/$workspace_id/tags/case-tags': typeof AuthWorkspacesWorkspace_idTagsCaseTagsIndexRoute
  '/workspaces/$workspace_id/tags/device-tags': typeof AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRoute
  '/workspaces/$workspace_id/tags/maintenance-tags': typeof AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRoute
  '/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id': typeof AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/customer-portal': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/settings': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/users': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRoute
  '/workspaces/$workspace_id/device-data/errors/$device_error_id': typeof AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRoute
  '/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id': typeof AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRoute
  '/workspaces/$workspace_id/inventory/incoming/$part_id': typeof AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRoute
  '/workspaces/$workspace_id/inventory/parts/$part_id': typeof AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id': typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id': typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRoute
  '/workspaces/$workspace_id/knowledge-hub/files/$file_id': typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRoute
  '/workspaces/$workspace_id/settings/users/$user_id': typeof AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRoute
  '/workspaces/$workspace_id/devices/$device_id/parts/$part_id': typeof AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRoute
  '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id': typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/free-trial': typeof FreeTrialRoute
  '/login': typeof LoginRoute
  '/login-sso': typeof LoginSsoRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-trial': typeof TermsTrialRoute
  '/_auth/end-of-trial': typeof AuthEndOfTrialRoute
  '/_auth/welcome': typeof AuthWelcomeRoute
  '/_auth/': typeof AuthIndexRoute
  '/customer-portal/': typeof CustomerPortalIndexRoute
  '/_auth/account/profile': typeof AuthAccountProfileRoute
  '/account/password/request': typeof AccountPasswordRequestRoute
  '/account/verify/complete-invite': typeof AccountVerifyCompleteInviteRoute
  '/account/verify/complete-signup': typeof AccountVerifyCompleteSignupRoute
  '/customer-portal/$public_portal_token/': typeof CustomerPortalPublic_portal_tokenIndexRoute
  '/_auth/account/password/reset': typeof AuthAccountPasswordResetRoute
  '/_auth/account/password/set': typeof AuthAccountPasswordSetRoute
  '/account/verify/$type/$token': typeof AccountVerifyTypeTokenRoute
  '/_auth/workspaces/$workspace_id/': typeof AuthWorkspacesWorkspace_idIndexRoute
  '/_auth/workspaces/$workspace_id/inventory/activities': typeof AuthWorkspacesWorkspace_idInventoryActivitiesRoute
  '/_auth/workspaces/$workspace_id/inventory/assembled': typeof AuthWorkspacesWorkspace_idInventoryAssembledRoute
  '/_auth/workspaces/$workspace_id/inventory/constraints': typeof AuthWorkspacesWorkspace_idInventoryConstraintsRoute
  '/_auth/workspaces/$workspace_id/inventory/picking': typeof AuthWorkspacesWorkspace_idInventoryPickingRoute
  '/_auth/workspaces/$workspace_id/settings/details': typeof AuthWorkspacesWorkspace_idSettingsDetailsRoute
  '/_auth/workspaces/$workspace_id/cases/': typeof AuthWorkspacesWorkspace_idCasesIndexRoute
  '/_auth/workspaces/$workspace_id/custom-inventory/': typeof AuthWorkspacesWorkspace_idCustomInventoryIndexRoute
  '/_auth/workspaces/$workspace_id/customer-workspaces/': typeof AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/': typeof AuthWorkspacesWorkspace_idDeploymentsIndexRoute
  '/_auth/workspaces/$workspace_id/device-data/': typeof AuthWorkspacesWorkspace_idDeviceDataIndexRoute
  '/_auth/workspaces/$workspace_id/devices/': typeof AuthWorkspacesWorkspace_idDevicesIndexRoute
  '/_auth/workspaces/$workspace_id/knowledge-hub/': typeof AuthWorkspacesWorkspace_idKnowledgeHubIndexRoute
  '/_auth/workspaces/$workspace_id/maintenance-strategies/': typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/': typeof AuthWorkspacesWorkspace_idMaintenancesIndexRoute
  '/_auth/workspaces/$workspace_id/service-jobs/': typeof AuthWorkspacesWorkspace_idServiceJobsIndexRoute
  '/_auth/workspaces/$workspace_id/tags/': typeof AuthWorkspacesWorkspace_idTagsIndexRoute
  '/_auth/workspaces/$workspace_id/cases/$case_id/': typeof AuthWorkspacesWorkspace_idCasesCase_idIndexRoute
  '/_auth/workspaces/$workspace_id/cases/insights/': typeof AuthWorkspacesWorkspace_idCasesInsightsIndexRoute
  '/_auth/workspaces/$workspace_id/cases/planner/': typeof AuthWorkspacesWorkspace_idCasesPlannerIndexRoute
  '/_auth/workspaces/$workspace_id/custom-inventory/devices/': typeof AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRoute
  '/_auth/workspaces/$workspace_id/custom-inventory/parts/': typeof AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRoute
  '/_auth/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/': typeof AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/$deployment_id/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRoute
  '/_auth/workspaces/$workspace_id/device-data/availability/': typeof AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRoute
  '/_auth/workspaces/$workspace_id/device-data/charts/': typeof AuthWorkspacesWorkspace_idDeviceDataChartsIndexRoute
  '/_auth/workspaces/$workspace_id/device-data/errors/': typeof AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRoute
  '/_auth/workspaces/$workspace_id/device-data/missions/': typeof AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRoute
  '/_auth/workspaces/$workspace_id/device-data/triggers/': typeof AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRoute
  '/_auth/workspaces/$workspace_id/devices/$device_id/': typeof AuthWorkspacesWorkspace_idDevicesDevice_idIndexRoute
  '/_auth/workspaces/$workspace_id/inventory/incoming/': typeof AuthWorkspacesWorkspace_idInventoryIncomingIndexRoute
  '/_auth/workspaces/$workspace_id/inventory/parts/': typeof AuthWorkspacesWorkspace_idInventoryPartsIndexRoute
  '/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/': typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRoute
  '/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/': typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRoute
  '/_auth/workspaces/$workspace_id/knowledge-hub/files/': typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRoute
  '/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/': typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/': typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/insights/': typeof AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/planner/': typeof AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRoute
  '/_auth/workspaces/$workspace_id/service-jobs/$service_job_id/': typeof AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRoute
  '/_auth/workspaces/$workspace_id/service-jobs/insights/': typeof AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRoute
  '/_auth/workspaces/$workspace_id/service-jobs/planner/': typeof AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRoute
  '/_auth/workspaces/$workspace_id/settings/users/': typeof AuthWorkspacesWorkspace_idSettingsUsersIndexRoute
  '/_auth/workspaces/$workspace_id/tags/case-tags/': typeof AuthWorkspacesWorkspace_idTagsCaseTagsIndexRoute
  '/_auth/workspaces/$workspace_id/tags/device-tags/': typeof AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRoute
  '/_auth/workspaces/$workspace_id/tags/maintenance-tags/': typeof AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRoute
  '/_auth/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/': typeof AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/$deployment_id/settings/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRoute
  '/_auth/workspaces/$workspace_id/device-data/errors/$device_error_id/': typeof AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRoute
  '/_auth/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/': typeof AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRoute
  '/_auth/workspaces/$workspace_id/inventory/incoming/$part_id/': typeof AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRoute
  '/_auth/workspaces/$workspace_id/inventory/parts/$part_id/': typeof AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRoute
  '/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/': typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRoute
  '/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/': typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRoute
  '/_auth/workspaces/$workspace_id/knowledge-hub/files/$file_id/': typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRoute
  '/_auth/workspaces/$workspace_id/settings/users/$user_id/': typeof AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/': typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRoute
  '/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/': typeof AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/': typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/free-trial'
    | '/login'
    | '/login-sso'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/terms-trial'
    | '/end-of-trial'
    | '/welcome'
    | '/customer-portal/'
    | '/account/profile'
    | '/account/password/request'
    | '/account/verify/complete-invite'
    | '/account/verify/complete-signup'
    | '/customer-portal/$public_portal_token/'
    | '/account/password/reset'
    | '/account/password/set'
    | '/account/verify/$type/$token'
    | '/workspaces/$workspace_id/'
    | '/workspaces/$workspace_id/inventory/activities'
    | '/workspaces/$workspace_id/inventory/assembled'
    | '/workspaces/$workspace_id/inventory/constraints'
    | '/workspaces/$workspace_id/inventory/picking'
    | '/workspaces/$workspace_id/settings/details'
    | '/workspaces/$workspace_id/cases/'
    | '/workspaces/$workspace_id/custom-inventory/'
    | '/workspaces/$workspace_id/customer-workspaces/'
    | '/workspaces/$workspace_id/deployments/'
    | '/workspaces/$workspace_id/device-data/'
    | '/workspaces/$workspace_id/devices/'
    | '/workspaces/$workspace_id/knowledge-hub/'
    | '/workspaces/$workspace_id/maintenance-strategies/'
    | '/workspaces/$workspace_id/maintenances/'
    | '/workspaces/$workspace_id/service-jobs/'
    | '/workspaces/$workspace_id/tags/'
    | '/workspaces/$workspace_id/cases/$case_id/'
    | '/workspaces/$workspace_id/cases/insights/'
    | '/workspaces/$workspace_id/cases/planner/'
    | '/workspaces/$workspace_id/custom-inventory/devices/'
    | '/workspaces/$workspace_id/custom-inventory/parts/'
    | '/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/'
    | '/workspaces/$workspace_id/deployments/$deployment_id/'
    | '/workspaces/$workspace_id/device-data/availability/'
    | '/workspaces/$workspace_id/device-data/charts/'
    | '/workspaces/$workspace_id/device-data/errors/'
    | '/workspaces/$workspace_id/device-data/missions/'
    | '/workspaces/$workspace_id/device-data/triggers/'
    | '/workspaces/$workspace_id/devices/$device_id/'
    | '/workspaces/$workspace_id/inventory/incoming/'
    | '/workspaces/$workspace_id/inventory/parts/'
    | '/workspaces/$workspace_id/knowledge-hub/case-templates/'
    | '/workspaces/$workspace_id/knowledge-hub/checklist-templates/'
    | '/workspaces/$workspace_id/knowledge-hub/files/'
    | '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/'
    | '/workspaces/$workspace_id/maintenances/$maintenance_id/'
    | '/workspaces/$workspace_id/maintenances/insights/'
    | '/workspaces/$workspace_id/maintenances/planner/'
    | '/workspaces/$workspace_id/service-jobs/$service_job_id/'
    | '/workspaces/$workspace_id/service-jobs/insights/'
    | '/workspaces/$workspace_id/service-jobs/planner/'
    | '/workspaces/$workspace_id/settings/users/'
    | '/workspaces/$workspace_id/tags/case-tags/'
    | '/workspaces/$workspace_id/tags/device-tags/'
    | '/workspaces/$workspace_id/tags/maintenance-tags/'
    | '/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/'
    | '/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/'
    | '/workspaces/$workspace_id/deployments/$deployment_id/settings/'
    | '/workspaces/$workspace_id/deployments/$deployment_id/users/'
    | '/workspaces/$workspace_id/device-data/errors/$device_error_id/'
    | '/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/'
    | '/workspaces/$workspace_id/inventory/incoming/$part_id/'
    | '/workspaces/$workspace_id/inventory/parts/$part_id/'
    | '/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/'
    | '/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/'
    | '/workspaces/$workspace_id/knowledge-hub/files/$file_id/'
    | '/workspaces/$workspace_id/settings/users/$user_id/'
    | '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/'
    | '/workspaces/$workspace_id/devices/$device_id/parts/$part_id/'
    | '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/free-trial'
    | '/login'
    | '/login-sso'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/terms-trial'
    | '/end-of-trial'
    | '/welcome'
    | '/'
    | '/customer-portal'
    | '/account/profile'
    | '/account/password/request'
    | '/account/verify/complete-invite'
    | '/account/verify/complete-signup'
    | '/customer-portal/$public_portal_token'
    | '/account/password/reset'
    | '/account/password/set'
    | '/account/verify/$type/$token'
    | '/workspaces/$workspace_id'
    | '/workspaces/$workspace_id/inventory/activities'
    | '/workspaces/$workspace_id/inventory/assembled'
    | '/workspaces/$workspace_id/inventory/constraints'
    | '/workspaces/$workspace_id/inventory/picking'
    | '/workspaces/$workspace_id/settings/details'
    | '/workspaces/$workspace_id/cases'
    | '/workspaces/$workspace_id/custom-inventory'
    | '/workspaces/$workspace_id/customer-workspaces'
    | '/workspaces/$workspace_id/deployments'
    | '/workspaces/$workspace_id/device-data'
    | '/workspaces/$workspace_id/devices'
    | '/workspaces/$workspace_id/knowledge-hub'
    | '/workspaces/$workspace_id/maintenance-strategies'
    | '/workspaces/$workspace_id/maintenances'
    | '/workspaces/$workspace_id/service-jobs'
    | '/workspaces/$workspace_id/tags'
    | '/workspaces/$workspace_id/cases/$case_id'
    | '/workspaces/$workspace_id/cases/insights'
    | '/workspaces/$workspace_id/cases/planner'
    | '/workspaces/$workspace_id/custom-inventory/devices'
    | '/workspaces/$workspace_id/custom-inventory/parts'
    | '/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id'
    | '/workspaces/$workspace_id/deployments/$deployment_id'
    | '/workspaces/$workspace_id/device-data/availability'
    | '/workspaces/$workspace_id/device-data/charts'
    | '/workspaces/$workspace_id/device-data/errors'
    | '/workspaces/$workspace_id/device-data/missions'
    | '/workspaces/$workspace_id/device-data/triggers'
    | '/workspaces/$workspace_id/devices/$device_id'
    | '/workspaces/$workspace_id/inventory/incoming'
    | '/workspaces/$workspace_id/inventory/parts'
    | '/workspaces/$workspace_id/knowledge-hub/case-templates'
    | '/workspaces/$workspace_id/knowledge-hub/checklist-templates'
    | '/workspaces/$workspace_id/knowledge-hub/files'
    | '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id'
    | '/workspaces/$workspace_id/maintenances/$maintenance_id'
    | '/workspaces/$workspace_id/maintenances/insights'
    | '/workspaces/$workspace_id/maintenances/planner'
    | '/workspaces/$workspace_id/service-jobs/$service_job_id'
    | '/workspaces/$workspace_id/service-jobs/insights'
    | '/workspaces/$workspace_id/service-jobs/planner'
    | '/workspaces/$workspace_id/settings/users'
    | '/workspaces/$workspace_id/tags/case-tags'
    | '/workspaces/$workspace_id/tags/device-tags'
    | '/workspaces/$workspace_id/tags/maintenance-tags'
    | '/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id'
    | '/workspaces/$workspace_id/deployments/$deployment_id/customer-portal'
    | '/workspaces/$workspace_id/deployments/$deployment_id/settings'
    | '/workspaces/$workspace_id/deployments/$deployment_id/users'
    | '/workspaces/$workspace_id/device-data/errors/$device_error_id'
    | '/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id'
    | '/workspaces/$workspace_id/inventory/incoming/$part_id'
    | '/workspaces/$workspace_id/inventory/parts/$part_id'
    | '/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id'
    | '/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id'
    | '/workspaces/$workspace_id/knowledge-hub/files/$file_id'
    | '/workspaces/$workspace_id/settings/users/$user_id'
    | '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id'
    | '/workspaces/$workspace_id/devices/$device_id/parts/$part_id'
    | '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id'
  id:
    | '__root__'
    | '/_auth'
    | '/free-trial'
    | '/login'
    | '/login-sso'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/terms-trial'
    | '/_auth/end-of-trial'
    | '/_auth/welcome'
    | '/_auth/'
    | '/customer-portal/'
    | '/_auth/account/profile'
    | '/account/password/request'
    | '/account/verify/complete-invite'
    | '/account/verify/complete-signup'
    | '/customer-portal/$public_portal_token/'
    | '/_auth/account/password/reset'
    | '/_auth/account/password/set'
    | '/account/verify/$type/$token'
    | '/_auth/workspaces/$workspace_id/'
    | '/_auth/workspaces/$workspace_id/inventory/activities'
    | '/_auth/workspaces/$workspace_id/inventory/assembled'
    | '/_auth/workspaces/$workspace_id/inventory/constraints'
    | '/_auth/workspaces/$workspace_id/inventory/picking'
    | '/_auth/workspaces/$workspace_id/settings/details'
    | '/_auth/workspaces/$workspace_id/cases/'
    | '/_auth/workspaces/$workspace_id/custom-inventory/'
    | '/_auth/workspaces/$workspace_id/customer-workspaces/'
    | '/_auth/workspaces/$workspace_id/deployments/'
    | '/_auth/workspaces/$workspace_id/device-data/'
    | '/_auth/workspaces/$workspace_id/devices/'
    | '/_auth/workspaces/$workspace_id/knowledge-hub/'
    | '/_auth/workspaces/$workspace_id/maintenance-strategies/'
    | '/_auth/workspaces/$workspace_id/maintenances/'
    | '/_auth/workspaces/$workspace_id/service-jobs/'
    | '/_auth/workspaces/$workspace_id/tags/'
    | '/_auth/workspaces/$workspace_id/cases/$case_id/'
    | '/_auth/workspaces/$workspace_id/cases/insights/'
    | '/_auth/workspaces/$workspace_id/cases/planner/'
    | '/_auth/workspaces/$workspace_id/custom-inventory/devices/'
    | '/_auth/workspaces/$workspace_id/custom-inventory/parts/'
    | '/_auth/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/'
    | '/_auth/workspaces/$workspace_id/deployments/$deployment_id/'
    | '/_auth/workspaces/$workspace_id/device-data/availability/'
    | '/_auth/workspaces/$workspace_id/device-data/charts/'
    | '/_auth/workspaces/$workspace_id/device-data/errors/'
    | '/_auth/workspaces/$workspace_id/device-data/missions/'
    | '/_auth/workspaces/$workspace_id/device-data/triggers/'
    | '/_auth/workspaces/$workspace_id/devices/$device_id/'
    | '/_auth/workspaces/$workspace_id/inventory/incoming/'
    | '/_auth/workspaces/$workspace_id/inventory/parts/'
    | '/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/'
    | '/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/'
    | '/_auth/workspaces/$workspace_id/knowledge-hub/files/'
    | '/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/'
    | '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/'
    | '/_auth/workspaces/$workspace_id/maintenances/insights/'
    | '/_auth/workspaces/$workspace_id/maintenances/planner/'
    | '/_auth/workspaces/$workspace_id/service-jobs/$service_job_id/'
    | '/_auth/workspaces/$workspace_id/service-jobs/insights/'
    | '/_auth/workspaces/$workspace_id/service-jobs/planner/'
    | '/_auth/workspaces/$workspace_id/settings/users/'
    | '/_auth/workspaces/$workspace_id/tags/case-tags/'
    | '/_auth/workspaces/$workspace_id/tags/device-tags/'
    | '/_auth/workspaces/$workspace_id/tags/maintenance-tags/'
    | '/_auth/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/'
    | '/_auth/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/'
    | '/_auth/workspaces/$workspace_id/deployments/$deployment_id/settings/'
    | '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/'
    | '/_auth/workspaces/$workspace_id/device-data/errors/$device_error_id/'
    | '/_auth/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/'
    | '/_auth/workspaces/$workspace_id/inventory/incoming/$part_id/'
    | '/_auth/workspaces/$workspace_id/inventory/parts/$part_id/'
    | '/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/'
    | '/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/'
    | '/_auth/workspaces/$workspace_id/knowledge-hub/files/$file_id/'
    | '/_auth/workspaces/$workspace_id/settings/users/$user_id/'
    | '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/'
    | '/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/'
    | '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  FreeTrialRoute: typeof FreeTrialRoute
  LoginRoute: typeof LoginRoute
  LoginSsoRoute: typeof LoginSsoRoute
  LogoutRoute: typeof LogoutRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  TermsTrialRoute: typeof TermsTrialRoute
  CustomerPortalIndexRoute: typeof CustomerPortalIndexRoute
  AccountPasswordRequestRoute: typeof AccountPasswordRequestRoute
  AccountVerifyCompleteInviteRoute: typeof AccountVerifyCompleteInviteRoute
  AccountVerifyCompleteSignupRoute: typeof AccountVerifyCompleteSignupRoute
  CustomerPortalPublic_portal_tokenIndexRoute: typeof CustomerPortalPublic_portal_tokenIndexRoute
  AccountVerifyTypeTokenRoute: typeof AccountVerifyTypeTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/free-trial': {
      id: '/free-trial'
      path: '/free-trial'
      fullPath: '/free-trial'
      preLoaderRoute: typeof FreeTrialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-sso': {
      id: '/login-sso'
      path: '/login-sso'
      fullPath: '/login-sso'
      preLoaderRoute: typeof LoginSsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-trial': {
      id: '/terms-trial'
      path: '/terms-trial'
      fullPath: '/terms-trial'
      preLoaderRoute: typeof TermsTrialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/end-of-trial': {
      id: '/_auth/end-of-trial'
      path: '/end-of-trial'
      fullPath: '/end-of-trial'
      preLoaderRoute: typeof AuthEndOfTrialRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/welcome': {
      id: '/_auth/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthWelcomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/customer-portal/': {
      id: '/customer-portal/'
      path: '/customer-portal'
      fullPath: '/customer-portal/'
      preLoaderRoute: typeof CustomerPortalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/account/profile': {
      id: '/_auth/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AuthAccountProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/account/password/request': {
      id: '/account/password/request'
      path: '/account/password/request'
      fullPath: '/account/password/request'
      preLoaderRoute: typeof AccountPasswordRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/verify/complete-invite': {
      id: '/account/verify/complete-invite'
      path: '/account/verify/complete-invite'
      fullPath: '/account/verify/complete-invite'
      preLoaderRoute: typeof AccountVerifyCompleteInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/verify/complete-signup': {
      id: '/account/verify/complete-signup'
      path: '/account/verify/complete-signup'
      fullPath: '/account/verify/complete-signup'
      preLoaderRoute: typeof AccountVerifyCompleteSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-portal/$public_portal_token/': {
      id: '/customer-portal/$public_portal_token/'
      path: '/customer-portal/$public_portal_token'
      fullPath: '/customer-portal/$public_portal_token/'
      preLoaderRoute: typeof CustomerPortalPublic_portal_tokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/account/password/reset': {
      id: '/_auth/account/password/reset'
      path: '/account/password/reset'
      fullPath: '/account/password/reset'
      preLoaderRoute: typeof AuthAccountPasswordResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account/password/set': {
      id: '/_auth/account/password/set'
      path: '/account/password/set'
      fullPath: '/account/password/set'
      preLoaderRoute: typeof AuthAccountPasswordSetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/': {
      id: '/_auth/workspaces/$workspace_id/'
      path: '/workspaces/$workspace_id'
      fullPath: '/workspaces/$workspace_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/account/verify/$type/$token': {
      id: '/account/verify/$type/$token'
      path: '/account/verify/$type/$token'
      fullPath: '/account/verify/$type/$token'
      preLoaderRoute: typeof AccountVerifyTypeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/workspaces/$workspace_id/cases/': {
      id: '/_auth/workspaces/$workspace_id/cases/'
      path: '/workspaces/$workspace_id/cases'
      fullPath: '/workspaces/$workspace_id/cases/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCasesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/custom-inventory/': {
      id: '/_auth/workspaces/$workspace_id/custom-inventory/'
      path: '/workspaces/$workspace_id/custom-inventory'
      fullPath: '/workspaces/$workspace_id/custom-inventory/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCustomInventoryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/customer-workspaces/': {
      id: '/_auth/workspaces/$workspace_id/customer-workspaces/'
      path: '/workspaces/$workspace_id/customer-workspaces'
      fullPath: '/workspaces/$workspace_id/customer-workspaces/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/deployments/': {
      id: '/_auth/workspaces/$workspace_id/deployments/'
      path: '/workspaces/$workspace_id/deployments'
      fullPath: '/workspaces/$workspace_id/deployments/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeploymentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/device-data/': {
      id: '/_auth/workspaces/$workspace_id/device-data/'
      path: '/workspaces/$workspace_id/device-data'
      fullPath: '/workspaces/$workspace_id/device-data/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeviceDataIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/devices/': {
      id: '/_auth/workspaces/$workspace_id/devices/'
      path: '/workspaces/$workspace_id/devices'
      fullPath: '/workspaces/$workspace_id/devices/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDevicesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/inventory/activities': {
      id: '/_auth/workspaces/$workspace_id/inventory/activities'
      path: '/workspaces/$workspace_id/inventory/activities'
      fullPath: '/workspaces/$workspace_id/inventory/activities'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idInventoryActivitiesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/inventory/assembled': {
      id: '/_auth/workspaces/$workspace_id/inventory/assembled'
      path: '/workspaces/$workspace_id/inventory/assembled'
      fullPath: '/workspaces/$workspace_id/inventory/assembled'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idInventoryAssembledRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/inventory/constraints': {
      id: '/_auth/workspaces/$workspace_id/inventory/constraints'
      path: '/workspaces/$workspace_id/inventory/constraints'
      fullPath: '/workspaces/$workspace_id/inventory/constraints'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idInventoryConstraintsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/inventory/picking': {
      id: '/_auth/workspaces/$workspace_id/inventory/picking'
      path: '/workspaces/$workspace_id/inventory/picking'
      fullPath: '/workspaces/$workspace_id/inventory/picking'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idInventoryPickingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/knowledge-hub/': {
      id: '/_auth/workspaces/$workspace_id/knowledge-hub/'
      path: '/workspaces/$workspace_id/knowledge-hub'
      fullPath: '/workspaces/$workspace_id/knowledge-hub/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/maintenance-strategies/': {
      id: '/_auth/workspaces/$workspace_id/maintenance-strategies/'
      path: '/workspaces/$workspace_id/maintenance-strategies'
      fullPath: '/workspaces/$workspace_id/maintenance-strategies/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/maintenances/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/'
      path: '/workspaces/$workspace_id/maintenances'
      fullPath: '/workspaces/$workspace_id/maintenances/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idMaintenancesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/service-jobs/': {
      id: '/_auth/workspaces/$workspace_id/service-jobs/'
      path: '/workspaces/$workspace_id/service-jobs'
      fullPath: '/workspaces/$workspace_id/service-jobs/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idServiceJobsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/settings/details': {
      id: '/_auth/workspaces/$workspace_id/settings/details'
      path: '/workspaces/$workspace_id/settings/details'
      fullPath: '/workspaces/$workspace_id/settings/details'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idSettingsDetailsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/tags/': {
      id: '/_auth/workspaces/$workspace_id/tags/'
      path: '/workspaces/$workspace_id/tags'
      fullPath: '/workspaces/$workspace_id/tags/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idTagsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/cases/$case_id/': {
      id: '/_auth/workspaces/$workspace_id/cases/$case_id/'
      path: '/workspaces/$workspace_id/cases/$case_id'
      fullPath: '/workspaces/$workspace_id/cases/$case_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCasesCase_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/cases/insights/': {
      id: '/_auth/workspaces/$workspace_id/cases/insights/'
      path: '/workspaces/$workspace_id/cases/insights'
      fullPath: '/workspaces/$workspace_id/cases/insights/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCasesInsightsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/cases/planner/': {
      id: '/_auth/workspaces/$workspace_id/cases/planner/'
      path: '/workspaces/$workspace_id/cases/planner'
      fullPath: '/workspaces/$workspace_id/cases/planner/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCasesPlannerIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/custom-inventory/devices/': {
      id: '/_auth/workspaces/$workspace_id/custom-inventory/devices/'
      path: '/workspaces/$workspace_id/custom-inventory/devices'
      fullPath: '/workspaces/$workspace_id/custom-inventory/devices/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/custom-inventory/parts/': {
      id: '/_auth/workspaces/$workspace_id/custom-inventory/parts/'
      path: '/workspaces/$workspace_id/custom-inventory/parts'
      fullPath: '/workspaces/$workspace_id/custom-inventory/parts/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/': {
      id: '/_auth/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/'
      path: '/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id'
      fullPath: '/workspaces/$workspace_id/customer-workspaces/$customer_workspace_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/deployments/$deployment_id/': {
      id: '/_auth/workspaces/$workspace_id/deployments/$deployment_id/'
      path: '/workspaces/$workspace_id/deployments/$deployment_id'
      fullPath: '/workspaces/$workspace_id/deployments/$deployment_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/device-data/availability/': {
      id: '/_auth/workspaces/$workspace_id/device-data/availability/'
      path: '/workspaces/$workspace_id/device-data/availability'
      fullPath: '/workspaces/$workspace_id/device-data/availability/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/device-data/charts/': {
      id: '/_auth/workspaces/$workspace_id/device-data/charts/'
      path: '/workspaces/$workspace_id/device-data/charts'
      fullPath: '/workspaces/$workspace_id/device-data/charts/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeviceDataChartsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/device-data/errors/': {
      id: '/_auth/workspaces/$workspace_id/device-data/errors/'
      path: '/workspaces/$workspace_id/device-data/errors'
      fullPath: '/workspaces/$workspace_id/device-data/errors/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/device-data/missions/': {
      id: '/_auth/workspaces/$workspace_id/device-data/missions/'
      path: '/workspaces/$workspace_id/device-data/missions'
      fullPath: '/workspaces/$workspace_id/device-data/missions/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/device-data/triggers/': {
      id: '/_auth/workspaces/$workspace_id/device-data/triggers/'
      path: '/workspaces/$workspace_id/device-data/triggers'
      fullPath: '/workspaces/$workspace_id/device-data/triggers/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/devices/$device_id/': {
      id: '/_auth/workspaces/$workspace_id/devices/$device_id/'
      path: '/workspaces/$workspace_id/devices/$device_id'
      fullPath: '/workspaces/$workspace_id/devices/$device_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDevicesDevice_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/inventory/incoming/': {
      id: '/_auth/workspaces/$workspace_id/inventory/incoming/'
      path: '/workspaces/$workspace_id/inventory/incoming'
      fullPath: '/workspaces/$workspace_id/inventory/incoming/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idInventoryIncomingIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/inventory/parts/': {
      id: '/_auth/workspaces/$workspace_id/inventory/parts/'
      path: '/workspaces/$workspace_id/inventory/parts'
      fullPath: '/workspaces/$workspace_id/inventory/parts/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idInventoryPartsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/': {
      id: '/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/'
      path: '/workspaces/$workspace_id/knowledge-hub/case-templates'
      fullPath: '/workspaces/$workspace_id/knowledge-hub/case-templates/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/': {
      id: '/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/'
      path: '/workspaces/$workspace_id/knowledge-hub/checklist-templates'
      fullPath: '/workspaces/$workspace_id/knowledge-hub/checklist-templates/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/knowledge-hub/files/': {
      id: '/_auth/workspaces/$workspace_id/knowledge-hub/files/'
      path: '/workspaces/$workspace_id/knowledge-hub/files'
      fullPath: '/workspaces/$workspace_id/knowledge-hub/files/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/': {
      id: '/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/'
      path: '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id'
      fullPath: '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/'
      path: '/workspaces/$workspace_id/maintenances/$maintenance_id'
      fullPath: '/workspaces/$workspace_id/maintenances/$maintenance_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/maintenances/insights/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/insights/'
      path: '/workspaces/$workspace_id/maintenances/insights'
      fullPath: '/workspaces/$workspace_id/maintenances/insights/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/maintenances/planner/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/planner/'
      path: '/workspaces/$workspace_id/maintenances/planner'
      fullPath: '/workspaces/$workspace_id/maintenances/planner/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/service-jobs/$service_job_id/': {
      id: '/_auth/workspaces/$workspace_id/service-jobs/$service_job_id/'
      path: '/workspaces/$workspace_id/service-jobs/$service_job_id'
      fullPath: '/workspaces/$workspace_id/service-jobs/$service_job_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/service-jobs/insights/': {
      id: '/_auth/workspaces/$workspace_id/service-jobs/insights/'
      path: '/workspaces/$workspace_id/service-jobs/insights'
      fullPath: '/workspaces/$workspace_id/service-jobs/insights/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/service-jobs/planner/': {
      id: '/_auth/workspaces/$workspace_id/service-jobs/planner/'
      path: '/workspaces/$workspace_id/service-jobs/planner'
      fullPath: '/workspaces/$workspace_id/service-jobs/planner/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/settings/users/': {
      id: '/_auth/workspaces/$workspace_id/settings/users/'
      path: '/workspaces/$workspace_id/settings/users'
      fullPath: '/workspaces/$workspace_id/settings/users/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idSettingsUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/tags/case-tags/': {
      id: '/_auth/workspaces/$workspace_id/tags/case-tags/'
      path: '/workspaces/$workspace_id/tags/case-tags'
      fullPath: '/workspaces/$workspace_id/tags/case-tags/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idTagsCaseTagsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/tags/device-tags/': {
      id: '/_auth/workspaces/$workspace_id/tags/device-tags/'
      path: '/workspaces/$workspace_id/tags/device-tags'
      fullPath: '/workspaces/$workspace_id/tags/device-tags/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/tags/maintenance-tags/': {
      id: '/_auth/workspaces/$workspace_id/tags/maintenance-tags/'
      path: '/workspaces/$workspace_id/tags/maintenance-tags'
      fullPath: '/workspaces/$workspace_id/tags/maintenance-tags/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/': {
      id: '/_auth/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/'
      path: '/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id'
      fullPath: '/workspaces/$workspace_id/custom-inventory/device-models/$device_model_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/': {
      id: '/_auth/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/'
      path: '/workspaces/$workspace_id/deployments/$deployment_id/customer-portal'
      fullPath: '/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/deployments/$deployment_id/settings/': {
      id: '/_auth/workspaces/$workspace_id/deployments/$deployment_id/settings/'
      path: '/workspaces/$workspace_id/deployments/$deployment_id/settings'
      fullPath: '/workspaces/$workspace_id/deployments/$deployment_id/settings/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/': {
      id: '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/'
      path: '/workspaces/$workspace_id/deployments/$deployment_id/users'
      fullPath: '/workspaces/$workspace_id/deployments/$deployment_id/users/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/device-data/errors/$device_error_id/': {
      id: '/_auth/workspaces/$workspace_id/device-data/errors/$device_error_id/'
      path: '/workspaces/$workspace_id/device-data/errors/$device_error_id'
      fullPath: '/workspaces/$workspace_id/device-data/errors/$device_error_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/': {
      id: '/_auth/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/'
      path: '/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id'
      fullPath: '/workspaces/$workspace_id/device-data/triggers/$device_data_trigger_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/inventory/incoming/$part_id/': {
      id: '/_auth/workspaces/$workspace_id/inventory/incoming/$part_id/'
      path: '/workspaces/$workspace_id/inventory/incoming/$part_id'
      fullPath: '/workspaces/$workspace_id/inventory/incoming/$part_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/inventory/parts/$part_id/': {
      id: '/_auth/workspaces/$workspace_id/inventory/parts/$part_id/'
      path: '/workspaces/$workspace_id/inventory/parts/$part_id'
      fullPath: '/workspaces/$workspace_id/inventory/parts/$part_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/': {
      id: '/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/'
      path: '/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id'
      fullPath: '/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/': {
      id: '/_auth/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/'
      path: '/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id'
      fullPath: '/workspaces/$workspace_id/knowledge-hub/checklist-templates/$checklist_template_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/knowledge-hub/files/$file_id/': {
      id: '/_auth/workspaces/$workspace_id/knowledge-hub/files/$file_id/'
      path: '/workspaces/$workspace_id/knowledge-hub/files/$file_id'
      fullPath: '/workspaces/$workspace_id/knowledge-hub/files/$file_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/settings/users/$user_id/': {
      id: '/_auth/workspaces/$workspace_id/settings/users/$user_id/'
      path: '/workspaces/$workspace_id/settings/users/$user_id'
      fullPath: '/workspaces/$workspace_id/settings/users/$user_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/': {
      id: '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/'
      path: '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id'
      fullPath: '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/': {
      id: '/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/'
      path: '/workspaces/$workspace_id/devices/$device_id/parts/$part_id'
      fullPath: '/workspaces/$workspace_id/devices/$device_id/parts/$part_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/'
      path: '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id'
      fullPath: '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/'
      preLoaderRoute: typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthEndOfTrialRoute: typeof AuthEndOfTrialRoute
  AuthWelcomeRoute: typeof AuthWelcomeRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAccountProfileRoute: typeof AuthAccountProfileRoute
  AuthAccountPasswordResetRoute: typeof AuthAccountPasswordResetRoute
  AuthAccountPasswordSetRoute: typeof AuthAccountPasswordSetRoute
  AuthWorkspacesWorkspace_idIndexRoute: typeof AuthWorkspacesWorkspace_idIndexRoute
  AuthWorkspacesWorkspace_idInventoryActivitiesRoute: typeof AuthWorkspacesWorkspace_idInventoryActivitiesRoute
  AuthWorkspacesWorkspace_idInventoryAssembledRoute: typeof AuthWorkspacesWorkspace_idInventoryAssembledRoute
  AuthWorkspacesWorkspace_idInventoryConstraintsRoute: typeof AuthWorkspacesWorkspace_idInventoryConstraintsRoute
  AuthWorkspacesWorkspace_idInventoryPickingRoute: typeof AuthWorkspacesWorkspace_idInventoryPickingRoute
  AuthWorkspacesWorkspace_idSettingsDetailsRoute: typeof AuthWorkspacesWorkspace_idSettingsDetailsRoute
  AuthWorkspacesWorkspace_idCasesIndexRoute: typeof AuthWorkspacesWorkspace_idCasesIndexRoute
  AuthWorkspacesWorkspace_idCustomInventoryIndexRoute: typeof AuthWorkspacesWorkspace_idCustomInventoryIndexRoute
  AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRoute: typeof AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRoute
  AuthWorkspacesWorkspace_idDeploymentsIndexRoute: typeof AuthWorkspacesWorkspace_idDeploymentsIndexRoute
  AuthWorkspacesWorkspace_idDeviceDataIndexRoute: typeof AuthWorkspacesWorkspace_idDeviceDataIndexRoute
  AuthWorkspacesWorkspace_idDevicesIndexRoute: typeof AuthWorkspacesWorkspace_idDevicesIndexRoute
  AuthWorkspacesWorkspace_idKnowledgeHubIndexRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubIndexRoute
  AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRoute: typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRoute
  AuthWorkspacesWorkspace_idMaintenancesIndexRoute: typeof AuthWorkspacesWorkspace_idMaintenancesIndexRoute
  AuthWorkspacesWorkspace_idServiceJobsIndexRoute: typeof AuthWorkspacesWorkspace_idServiceJobsIndexRoute
  AuthWorkspacesWorkspace_idTagsIndexRoute: typeof AuthWorkspacesWorkspace_idTagsIndexRoute
  AuthWorkspacesWorkspace_idCasesCase_idIndexRoute: typeof AuthWorkspacesWorkspace_idCasesCase_idIndexRoute
  AuthWorkspacesWorkspace_idCasesInsightsIndexRoute: typeof AuthWorkspacesWorkspace_idCasesInsightsIndexRoute
  AuthWorkspacesWorkspace_idCasesPlannerIndexRoute: typeof AuthWorkspacesWorkspace_idCasesPlannerIndexRoute
  AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRoute: typeof AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRoute
  AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRoute: typeof AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRoute
  AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRoute: typeof AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRoute
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRoute
  AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRoute: typeof AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRoute
  AuthWorkspacesWorkspace_idDeviceDataChartsIndexRoute: typeof AuthWorkspacesWorkspace_idDeviceDataChartsIndexRoute
  AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRoute: typeof AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRoute
  AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRoute: typeof AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRoute
  AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRoute: typeof AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRoute
  AuthWorkspacesWorkspace_idDevicesDevice_idIndexRoute: typeof AuthWorkspacesWorkspace_idDevicesDevice_idIndexRoute
  AuthWorkspacesWorkspace_idInventoryIncomingIndexRoute: typeof AuthWorkspacesWorkspace_idInventoryIncomingIndexRoute
  AuthWorkspacesWorkspace_idInventoryPartsIndexRoute: typeof AuthWorkspacesWorkspace_idInventoryPartsIndexRoute
  AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRoute
  AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRoute
  AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRoute
  AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRoute: typeof AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRoute
  AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRoute: typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRoute
  AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRoute: typeof AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRoute
  AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRoute: typeof AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRoute
  AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRoute: typeof AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRoute
  AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRoute: typeof AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRoute
  AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRoute: typeof AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRoute
  AuthWorkspacesWorkspace_idSettingsUsersIndexRoute: typeof AuthWorkspacesWorkspace_idSettingsUsersIndexRoute
  AuthWorkspacesWorkspace_idTagsCaseTagsIndexRoute: typeof AuthWorkspacesWorkspace_idTagsCaseTagsIndexRoute
  AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRoute: typeof AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRoute
  AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRoute: typeof AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRoute
  AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRoute: typeof AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRoute
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRoute
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRoute
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRoute
  AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRoute: typeof AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRoute
  AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRoute: typeof AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRoute
  AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRoute: typeof AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRoute
  AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRoute: typeof AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRoute
  AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRoute
  AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRoute
  AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRoute: typeof AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRoute
  AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRoute: typeof AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRoute
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRoute: typeof AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRoute
  AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRoute: typeof AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRoute
  AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRoute: typeof AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthEndOfTrialRoute: AuthEndOfTrialRoute,
  AuthWelcomeRoute: AuthWelcomeRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAccountProfileRoute: AuthAccountProfileRoute,
  AuthAccountPasswordResetRoute: AuthAccountPasswordResetRoute,
  AuthAccountPasswordSetRoute: AuthAccountPasswordSetRoute,
  AuthWorkspacesWorkspace_idIndexRoute: AuthWorkspacesWorkspace_idIndexRoute,
  AuthWorkspacesWorkspace_idInventoryActivitiesRoute:
    AuthWorkspacesWorkspace_idInventoryActivitiesRoute,
  AuthWorkspacesWorkspace_idInventoryAssembledRoute:
    AuthWorkspacesWorkspace_idInventoryAssembledRoute,
  AuthWorkspacesWorkspace_idInventoryConstraintsRoute:
    AuthWorkspacesWorkspace_idInventoryConstraintsRoute,
  AuthWorkspacesWorkspace_idInventoryPickingRoute:
    AuthWorkspacesWorkspace_idInventoryPickingRoute,
  AuthWorkspacesWorkspace_idSettingsDetailsRoute:
    AuthWorkspacesWorkspace_idSettingsDetailsRoute,
  AuthWorkspacesWorkspace_idCasesIndexRoute:
    AuthWorkspacesWorkspace_idCasesIndexRoute,
  AuthWorkspacesWorkspace_idCustomInventoryIndexRoute:
    AuthWorkspacesWorkspace_idCustomInventoryIndexRoute,
  AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRoute:
    AuthWorkspacesWorkspace_idCustomerWorkspacesIndexRoute,
  AuthWorkspacesWorkspace_idDeploymentsIndexRoute:
    AuthWorkspacesWorkspace_idDeploymentsIndexRoute,
  AuthWorkspacesWorkspace_idDeviceDataIndexRoute:
    AuthWorkspacesWorkspace_idDeviceDataIndexRoute,
  AuthWorkspacesWorkspace_idDevicesIndexRoute:
    AuthWorkspacesWorkspace_idDevicesIndexRoute,
  AuthWorkspacesWorkspace_idKnowledgeHubIndexRoute:
    AuthWorkspacesWorkspace_idKnowledgeHubIndexRoute,
  AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRoute:
    AuthWorkspacesWorkspace_idMaintenanceStrategiesIndexRoute,
  AuthWorkspacesWorkspace_idMaintenancesIndexRoute:
    AuthWorkspacesWorkspace_idMaintenancesIndexRoute,
  AuthWorkspacesWorkspace_idServiceJobsIndexRoute:
    AuthWorkspacesWorkspace_idServiceJobsIndexRoute,
  AuthWorkspacesWorkspace_idTagsIndexRoute:
    AuthWorkspacesWorkspace_idTagsIndexRoute,
  AuthWorkspacesWorkspace_idCasesCase_idIndexRoute:
    AuthWorkspacesWorkspace_idCasesCase_idIndexRoute,
  AuthWorkspacesWorkspace_idCasesInsightsIndexRoute:
    AuthWorkspacesWorkspace_idCasesInsightsIndexRoute,
  AuthWorkspacesWorkspace_idCasesPlannerIndexRoute:
    AuthWorkspacesWorkspace_idCasesPlannerIndexRoute,
  AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRoute:
    AuthWorkspacesWorkspace_idCustomInventoryDevicesIndexRoute,
  AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRoute:
    AuthWorkspacesWorkspace_idCustomInventoryPartsIndexRoute,
  AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRoute:
    AuthWorkspacesWorkspace_idCustomerWorkspacesCustomer_workspace_idIndexRoute,
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRoute:
    AuthWorkspacesWorkspace_idDeploymentsDeployment_idIndexRoute,
  AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRoute:
    AuthWorkspacesWorkspace_idDeviceDataAvailabilityIndexRoute,
  AuthWorkspacesWorkspace_idDeviceDataChartsIndexRoute:
    AuthWorkspacesWorkspace_idDeviceDataChartsIndexRoute,
  AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRoute:
    AuthWorkspacesWorkspace_idDeviceDataErrorsIndexRoute,
  AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRoute:
    AuthWorkspacesWorkspace_idDeviceDataMissionsIndexRoute,
  AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRoute:
    AuthWorkspacesWorkspace_idDeviceDataTriggersIndexRoute,
  AuthWorkspacesWorkspace_idDevicesDevice_idIndexRoute:
    AuthWorkspacesWorkspace_idDevicesDevice_idIndexRoute,
  AuthWorkspacesWorkspace_idInventoryIncomingIndexRoute:
    AuthWorkspacesWorkspace_idInventoryIncomingIndexRoute,
  AuthWorkspacesWorkspace_idInventoryPartsIndexRoute:
    AuthWorkspacesWorkspace_idInventoryPartsIndexRoute,
  AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRoute:
    AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesIndexRoute,
  AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRoute:
    AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesIndexRoute,
  AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRoute:
    AuthWorkspacesWorkspace_idKnowledgeHubFilesIndexRoute,
  AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRoute:
    AuthWorkspacesWorkspace_idMaintenanceStrategiesMaintenance_strategy_idIndexRoute,
  AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRoute:
    AuthWorkspacesWorkspace_idMaintenancesMaintenance_idIndexRoute,
  AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRoute:
    AuthWorkspacesWorkspace_idMaintenancesInsightsIndexRoute,
  AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRoute:
    AuthWorkspacesWorkspace_idMaintenancesPlannerIndexRoute,
  AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRoute:
    AuthWorkspacesWorkspace_idServiceJobsService_job_idIndexRoute,
  AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRoute:
    AuthWorkspacesWorkspace_idServiceJobsInsightsIndexRoute,
  AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRoute:
    AuthWorkspacesWorkspace_idServiceJobsPlannerIndexRoute,
  AuthWorkspacesWorkspace_idSettingsUsersIndexRoute:
    AuthWorkspacesWorkspace_idSettingsUsersIndexRoute,
  AuthWorkspacesWorkspace_idTagsCaseTagsIndexRoute:
    AuthWorkspacesWorkspace_idTagsCaseTagsIndexRoute,
  AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRoute:
    AuthWorkspacesWorkspace_idTagsDeviceTagsIndexRoute,
  AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRoute:
    AuthWorkspacesWorkspace_idTagsMaintenanceTagsIndexRoute,
  AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRoute:
    AuthWorkspacesWorkspace_idCustomInventoryDeviceModelsDevice_model_idIndexRoute,
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRoute:
    AuthWorkspacesWorkspace_idDeploymentsDeployment_idCustomerPortalIndexRoute,
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRoute:
    AuthWorkspacesWorkspace_idDeploymentsDeployment_idSettingsIndexRoute,
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRoute:
    AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersIndexRoute,
  AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRoute:
    AuthWorkspacesWorkspace_idDeviceDataErrorsDevice_error_idIndexRoute,
  AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRoute:
    AuthWorkspacesWorkspace_idDeviceDataTriggersDevice_data_trigger_idIndexRoute,
  AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRoute:
    AuthWorkspacesWorkspace_idInventoryIncomingPart_idIndexRoute,
  AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRoute:
    AuthWorkspacesWorkspace_idInventoryPartsPart_idIndexRoute,
  AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRoute:
    AuthWorkspacesWorkspace_idKnowledgeHubCaseTemplatesCase_template_idIndexRoute,
  AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRoute:
    AuthWorkspacesWorkspace_idKnowledgeHubChecklistTemplatesChecklist_template_idIndexRoute,
  AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRoute:
    AuthWorkspacesWorkspace_idKnowledgeHubFilesFile_idIndexRoute,
  AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRoute:
    AuthWorkspacesWorkspace_idSettingsUsersUser_idIndexRoute,
  AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRoute:
    AuthWorkspacesWorkspace_idDeploymentsDeployment_idUsersUser_idIndexRoute,
  AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRoute:
    AuthWorkspacesWorkspace_idDevicesDevice_idPartsPart_idIndexRoute,
  AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRoute:
    AuthWorkspacesWorkspace_idMaintenancesMaintenance_idDevicesDevice_idIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  FreeTrialRoute: FreeTrialRoute,
  LoginRoute: LoginRoute,
  LoginSsoRoute: LoginSsoRoute,
  LogoutRoute: LogoutRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  TermsTrialRoute: TermsTrialRoute,
  CustomerPortalIndexRoute: CustomerPortalIndexRoute,
  AccountPasswordRequestRoute: AccountPasswordRequestRoute,
  AccountVerifyCompleteInviteRoute: AccountVerifyCompleteInviteRoute,
  AccountVerifyCompleteSignupRoute: AccountVerifyCompleteSignupRoute,
  CustomerPortalPublic_portal_tokenIndexRoute:
    CustomerPortalPublic_portal_tokenIndexRoute,
  AccountVerifyTypeTokenRoute: AccountVerifyTypeTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
